import { Controller } from "@hotwired/stimulus"
import { runMcaptcha } from "../lib/mcaptcha"

// Ajoute un widget mCaptcha (proof-of-work, hébergé sur l'infra ARKO) aux 4
// formulaires publics de soumission (org / tender / event / document).
// Pattern repris d'arkowebsite : on récupère la config (sitekey + url) via
// /captcha/config, on rend une case à cocher "Je ne suis pas un robot",
// la résolution PoW se fait dans un Web Worker au moment du clic, puis le
// token signé est placé dans un champ caché soumis avec le form.

export default class extends Controller {
  static targets = ["container", "check", "label", "token", "error", "submit"]
  static values = { fieldName: { type: String, default: "mcaptcha__token" } }

  connect() {
    this.cfg = null
    this.tokenReady = false

    // Pas de container = utilisateur signé (le partial ne rend rien). Le serveur
    // skippe aussi la vérif via `verify_submission_captcha!`. On laisse passer.
    if (!this.hasContainerTarget) {
      this.tokenReady = true
      return
    }

    fetch('/captcha/config', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cfg => {
        this.cfg = cfg
        if (this.hasContainerTarget && cfg.mcaptcha_sitekey) {
          this.renderWidget()
        } else if (this.hasContainerTarget) {
          // mCaptcha non configuré en env → on n'affiche rien et on laisse passer
          this.containerTarget.innerHTML = ''
          this.tokenReady = true
        }
      })
      .catch(() => {
        // En cas de panne du endpoint config, on ne bloque pas le formulaire
        this.tokenReady = true
      })
  }

  renderWidget() {
    const fieldName = this.fieldNameValue
    this.containerTarget.innerHTML =
      '<div class="flex items-center gap-3 px-4 py-3 rounded border border-gray-300 bg-white">' +
        '<input type="checkbox" data-submission-captcha-target="check" data-action="change->submission-captcha#solve" class="w-5 h-5 cursor-pointer accent-bgmembre">' +
        '<label data-submission-captcha-target="label" class="cursor-pointer text-sm text-gray-700 m-0">Je ne suis pas un robot</label>' +
        '<input type="hidden" name="' + fieldName + '" data-submission-captcha-target="token">' +
      '</div>'
  }

  solve() {
    if (!this.checkTarget.checked || !this.cfg) return
    this.checkTarget.disabled = true
    this.labelTarget.textContent = 'Vérification...'

    runMcaptcha(this.cfg)
      .then(token => {
        this.tokenTarget.value = token
        this.tokenReady = true
        this.labelTarget.textContent = 'Vérifié ✓'
        this.labelTarget.classList.add('text-green-600')
      })
      .catch(() => {
        this.tokenReady = false
        this.labelTarget.textContent = 'Erreur — réessayez'
        this.labelTarget.classList.add('text-red-600')
        this.checkTarget.checked = false
        this.checkTarget.disabled = false
      })
  }

  submit(event) {
    if (this.tokenReady) return
    event.preventDefault()
    if (this.hasErrorTarget) {
      this.errorTarget.style.display = 'block'
      this.errorTarget.textContent = 'Veuillez valider le captcha avant d\'envoyer.'
    }
  }
}
